export interface Phone {
  phone: string;
  default: boolean;
}

